<ng-container *ngIf="!item.hidden">
  <a
    class="nav-link"
    [routerLink]="[item.url]"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
    [ngClass]="{ 'active': active }"
    (click)="setActive()"
    matRipple
    *ngIf="item.url && !item.function"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <span
    class="nav-link"
    (click)="item.function(); setActive()"
    (keyup)="($event.key === 'Enter' || $event.key === ' ') && item.function(); setActive()"
    [ngClass]="{ 'active': active }"
    tabindex="0"
    matRipple
    *ngIf="!item.url && item.function"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </span>

  <a
    class="nav-link"
    (click)="item.function(); setActive()"
    [routerLink]="[item.url]"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
    [ngClass]="{ 'active': active }"
    matRipple
    *ngIf="item.url && item.function"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <ng-template #itemContent>
    <mat-icon
      class="nav-link-icon"
      *ngIf="item.icon"
    >{{item.icon}}</mat-icon>
    <span class="nav-link-title">{{item.title}}</span>
    <span
      class="nav-link-badge"
      *ngIf="item.badge"
      [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}"
    >
      {{item.badge.title}}
    </span>
  </ng-template>
</ng-container>
